const removeUrlParam = (key, sourceURL) => {
	let url = sourceURL.split("?")[0];
	let paramsArray = [];
	const queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
	if (queryString !== "") {
		paramsArray = queryString.split("&");
		for (let i = paramsArray.length - 1; i >= 0; i -= 1) {
			const paramItem = paramsArray[i];
			const param = paramItem.split("=")[0];
			if (param === key) {
				paramsArray.splice(i, 1);
			}
		}
		if (paramsArray.length) url = `${url}?${paramsArray.join("&")}`;
	}
	return url;
};

export default removeUrlParam;
